import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'pm-version-is-fetching',
  templateUrl: './version-is-fetching.component.html',
  styleUrls: ['./version-is-fetching.component.scss'],
  imports: [MatProgressSpinner, TranslateModule],
})
export class VersionIsFetchingComponent {}
